<template>
  <section>
    <mov-dropdown
      v-model="selectedOption"
      :disabled="disabled"
      :loading="hasData"
      :selectedText="selectedText"
      :multiple="multiple"
      @input="e => $emit('input', e)"
    >
      <b-dropdown-item
        v-for="state in states"
        :key="state"
        :value="state"
      >
        {{ $t(`States.${state}`) | upperCase }}
      </b-dropdown-item>
    </mov-dropdown>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MovDropdown from '@/components/miscellaneous/MovDropdown'

export default {
  name: 'MovStatesFilter',
  components: {
    MovDropdown
  },
  props: {
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedOption: null,
      disabled: false,
      hasData: false
    }
  },
  computed: {
    ...mapGetters('filters', ['states']),
    selectedText () {
      if (this.multiple) {
        const countItems = this.selectedOption &&
          this.selectedOption.length
          ? this.selectedOption.length
          : 0

        return this.$t('States.multiSelect', { items: countItems })
      }

      if (!this.multiple && this.selectedOption) {
        const state = this.states.filter(s => s === this.selectedOption)
        return this.$t(`States.${state}`).toUpperCase()
      }

      return this.$t('Filters.labelFilterState')
    }
  },
  async mounted () {
    this.disabled = true
    this.hasData = await this.getStates()

    if (this.hasData) this.disabled = false
    this.$eventBus.$on('cleanFilters', this.callback)
  },
  beforeDestroy () {
    this.$eventBus.$off('cleanFilters', this.callback)
  },
  methods: {
    ...mapActions('filters', ['getStates']),
    callback () {
      this.selectedOption = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/MovStatesFilter.vue